import React, { useEffect, useState, useRef } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTooltip,
  I2cPhoneField,
  I2cIcon,
  I2cFileUpload,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { aplicableProgramFeatures } from "./FieldsListingLabels";
import CreditLimits from "./CreditLimits";
import PaymentCard from "./PaymentCard";
import "../../PrepaidComponents/Prepaid.scss";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import FilesUploadService from "../../../Services/FilesUploadService";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { emailAdressValidator } from "../../../Utils/stringUtls";
import { useMutation } from "react-query";
const generalErrorMessage = "Field is required";

export const validationSchema = Yup.object({
  pf_applicable_pf: Yup.array()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_applicable_pf_other: Yup.string().when(["pf_applicable_pf"], {
    is: (pf_applicable_pf) => pf_applicable_pf.includes(11),
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_card_be_charged: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_type_of_credit_line: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_type_of_credit_line_company_name: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_contact_name: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_job_title: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_phone_number: Yup.string().when(
    "pf_type_of_credit_line",
    {
      is: (pf_type_of_credit_line) =>
        pf_type_of_credit_line && pf_type_of_credit_line === "secure",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_type_of_credit_line_email: Yup.string().when("pf_type_of_credit_line", {
    is: (pf_type_of_credit_line) =>
      pf_type_of_credit_line && pf_type_of_credit_line === "secure",
    then: () =>
      Yup.string()
        .required(generalErrorMessage)
        .test("", "", function (item) {
          // this.parent gives the whole parent
          return emailAdressValidator(item);
        }),
    otherwise: () => Yup.string().optional(),
  }),
  pf_credit_decisioning: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_credit_decisioning_fico_vendor: Yup.string().when(
    "pf_credit_decisioning",
    {
      is: (pf_credit_decisioning) =>
        pf_credit_decisioning && pf_credit_decisioning === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_fico_vendor_other: Yup.string().when(
    ["pf_credit_decisioning", "pf_credit_decisioning_fico_vendor"],
    {
      is: (pf_credit_decisioning, pf_credit_decisioning_fico_vendor) =>
        pf_credit_decisioning === "yes" &&
        pf_credit_decisioning_fico_vendor === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc: Yup.string().when("pf_credit_decisioning", {
    is: (pf_credit_decisioning) =>
      pf_credit_decisioning && pf_credit_decisioning === "no",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),

  pf_credit_decisioning_chc_company_name: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_contact_name: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_job_title: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_phone_number: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_decisioning_chc_email: Yup.string().when(
    ["pf_credit_decisioning_chc", "pf_credit_decisioning"],
    {
      is: (pf_credit_decisioning_chc, pf_credit_decisioning) =>
        pf_credit_decisioning_chc &&
        pf_credit_decisioning_chc === "other" &&
        pf_credit_decisioning === "no",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_workflow_and_decision_file: Yup.string().optional(),
  pf_manual_review: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_manual_review_company_name: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_contact_name: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_job_title: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_phone_number: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_manual_review_email: Yup.string().when("pf_manual_review", {
    is: (pf_manual_review) => pf_manual_review && pf_manual_review === "yes",
    then: () =>
      Yup.string()
        .required(generalErrorMessage)
        .test("", "", function (item) {
          // this.parent gives the whole parent
          return emailAdressValidator(item);
        }),
    otherwise: () => Yup.string().optional(),
  }),

  pf_credit_limit: Yup.array().optional(),
  pf_credit_limit_modification: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_clm_delinquent: Yup.array().when("pf_credit_limit_modification", {
    is: (pf_credit_limit_modification) =>
      pf_credit_limit_modification === "yes",
    then: () =>
      Yup.array()
        .of(
          Yup.object({
            pf_clm_deliquency_action: Yup.string()
              .required(generalErrorMessage)
              .min(1, generalErrorMessage),
            pf_clm_days_past_dueL: Yup.string()
              .required(generalErrorMessage)
              .min(1, generalErrorMessage),
            pf_clm_days_month_opt: Yup.string()
              .required(generalErrorMessage)
              .min(1, generalErrorMessage),
          }),
        )
        .min(1, generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),

  pf_kyc_process: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_kyc_conduct: Yup.string().when(["pf_kyc_process"], {
    is: (pf_kyc_process) => pf_kyc_process === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_kyc_conduct_other_company: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_contact_name: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_title: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_phone: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyc_conduct_other_email: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pf_kyc_conduct_other_address: Yup.string().when(
    ["pf_kyc_conduct", "pf_kyc_process"],
    {
      is: (pf_kyc_conduct, pf_kyc_process) =>
        pf_kyc_conduct &&
        pf_kyc_conduct === "other" &&
        pf_kyc_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pf_kyb_process: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_kyb_responsibility: Yup.string().when(["pf_kyb_process"], {
    is: (pf_kyb_process) => pf_kyb_process === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_kyb_responsibility_other_company: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_contact_name: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_title: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_phone: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_kyb_responsibility_other_email: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),

  pf_kyb_responsibility_other_address: Yup.string().when(
    ["pf_kyb_responsibility", "pf_kyb_process"],
    {
      is: (pf_kyb_responsibility, pf_kyb_process) =>
        pf_kyb_responsibility &&
        pf_kyb_responsibility === "other" &&
        pf_kyb_process === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_card_order_placement: Yup.array().optional(),
  pf_card_order_placement_channel: Yup.array().optional(),
  pf_card_order_placement_channel_other: Yup.string().when(
    ["pf_card_order_placement_channel"],
    {
      is: (pf_card_order_placement_channel) =>
        pf_card_order_placement_channel &&
        pf_card_order_placement_channel.includes(5),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_card_activation_channel: Yup.array().optional(),
  pf_card_activation_channel_other: Yup.string().when(
    ["pf_card_activation_channel"],
    {
      is: (pf_card_activation_channel) =>
        pf_card_activation_channel && pf_card_activation_channel.includes(5),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_pin_management: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_pin_manage_default_pin: Yup.string().when(["pf_pin_management"], {
    is: (pf_pin_management) =>
      pf_pin_management && pf_pin_management === "default-pin",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_pin_manage_default_pin_other: Yup.string().when(
    ["pf_pin_management", "pf_pin_manage_default_pin"],
    {
      is: (pf_pin_management, pf_pin_manage_default_pin) =>
        pf_pin_management === "default-pin" &&
        pf_pin_manage_default_pin === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_pin_mailer: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_offline_pin_support: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_consumer_payment_opt: Yup.array().optional(),
  pf_consumer_payment_opt_other: Yup.string().when(
    ["pf_consumer_payment_opt"],
    {
      is: (pf_consumer_payment_opt) =>
        pf_consumer_payment_opt && pf_consumer_payment_opt.includes(3),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  //

  pf_lockbox_services: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_lockbox_services_other_company: Yup.string().when(
    ["pf_lockbox_services"],
    {
      is: (pf_lockbox_services) =>
        pf_lockbox_services && pf_lockbox_services === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_lockbox_services_other_contact_name: Yup.string().when(
    ["pf_lockbox_services"],
    {
      is: (pf_lockbox_services) =>
        pf_lockbox_services && pf_lockbox_services === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_lockbox_services_other_title: Yup.string().when(["pf_lockbox_services"], {
    is: (pf_lockbox_services) =>
      pf_lockbox_services && pf_lockbox_services === "other",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_lockbox_services_other_phone: Yup.string().when(["pf_lockbox_services"], {
    is: (pf_lockbox_services) =>
      pf_lockbox_services && pf_lockbox_services === "other",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_lockbox_services_other_email: Yup.string().when(["pf_lockbox_services"], {
    is: (pf_lockbox_services) =>
      pf_lockbox_services && pf_lockbox_services === "other",
    then: () =>
      Yup.string()
        .required(generalErrorMessage)
        .test("", "", function (item) {
          // this.parent gives the whole parent
          return emailAdressValidator(item);
        }),
    otherwise: () => Yup.string().optional(),
  }),
  pf_min_payment_threshold: Yup.string().optional(),
  pf_min_payment_additional_amount: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_payment_dist_opt_greater_min: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_payment_dist_opt_for_min: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_min_pc_pcalc_method: Yup.string().optional(),
  pf_min_pc_pprcntg_value: Yup.string().optional(),
  pf_min_pc_scalc_method: Yup.string().optional(),
  pf_min_pc_sprcntg_value: Yup.string().optional(),
  pf_payment_due_date_policy: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_payment_due_date_policy_fixed_date: Yup.string().when(
    ["pf_payment_due_date_policy"],
    {
      is: (pf_payment_due_date_policy) =>
        pf_payment_due_date_policy &&
        pf_payment_due_date_policy === "fixed-date",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_payment_due_date_policy_no_of_days: Yup.string().when(
    ["pf_payment_due_date_policy"],
    {
      is: (pf_payment_due_date_policy) =>
        pf_payment_due_date_policy &&
        pf_payment_due_date_policy === "no-of-days",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_late_payment_penalty: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_late_payment_fee: Yup.string().when(["pf_late_payment_penalty"], {
    is: (pf_late_payment_penalty) =>
      pf_late_payment_penalty && pf_late_payment_penalty === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_grace_period: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_grace_period_days: Yup.string().when(["pf_grace_period"], {
    is: (pf_grace_period) => pf_grace_period && pf_grace_period === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  pf_card_account_statement: Yup.array().optional(),
  pf_statement_generation: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_statment_generation_date: Yup.string().when(["pf_statement_generation"], {
    is: (pf_statement_generation) =>
      pf_statement_generation && pf_statement_generation === "yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),

  pf_credit_card_collection_detail: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_credit_card_collection_detail_provider: Yup.string().when(
    ["pf_credit_card_collection_detail"],
    {
      is: (pf_credit_card_collection_detail) =>
        pf_credit_card_collection_detail &&
        pf_credit_card_collection_detail === "yes",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_card_collection_detail_provider_other: Yup.string().when(
    [
      "pf_credit_card_collection_detail",
      "pf_credit_card_collection_detail_provider",
    ],
    {
      is: (
        pf_credit_card_collection_detail,
        pf_credit_card_collection_detail_provider,
      ) =>
        pf_credit_card_collection_detail === "yes" &&
        pf_credit_card_collection_detail_provider === "other",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_credit_bureau_report_required: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_credit_reporting_bureaus: Yup.array().when(
    ["pf_credit_bureau_report_required"],
    {
      is: (pf_credit_bureau_report_required) =>
        pf_credit_bureau_report_required &&
        pf_credit_bureau_report_required === "yes",
      then: () =>
        Yup.array().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.array().optional(),
    },
  ),
  pf_credit_reporting_bureaus_other: Yup.string().when(
    ["pf_credit_bureau_report_required", "pf_credit_reporting_bureaus"],
    {
      is: (pf_credit_bureau_report_required, pf_credit_reporting_bureaus) =>
        pf_credit_bureau_report_required === "yes" &&
        pf_credit_reporting_bureaus.includes(3),
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_card_usage_restriction: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_cash_advance_limit: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_cardholder_notification: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_cardholder_notification: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),
  pf_cardholder_notification_channels: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_customer_support_channels: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_customer_support_who_will_provide: Yup.string()
    .required(generalErrorMessage)
    .min(1, generalErrorMessage),

  pf_customer_support_provider_other_company: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_contact_name: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_title: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_phone: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () => Yup.string().required(generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    },
  ),
  pf_customer_support_provider_other_email: Yup.string().when(
    ["pf_customer_support_who_will_provide"],
    {
      is: (pf_customer_support_who_will_provide) =>
        pf_customer_support_who_will_provide &&
        pf_customer_support_who_will_provide === "client-third-party",
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    },
  ),
});

const GeneralInfoProgramFeatures = ({
  setFormValidStates,
  setAddFormData,
  addFormData,
  formDataJson,
  isFetching,
}) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      pf_applicable_pf: [],
      pf_applicable_pf_other: "",
      pf_card_be_charged: "",
      pf_type_of_credit_line: "",
      pf_type_of_credit_line_company_name: "",
      pf_type_of_credit_line_contact_name: "",
      pf_type_of_credit_line_job_title: "",
      pf_type_of_credit_line_phone_number: "",
      pf_type_of_credit_line_phone_number_code: "",
      pf_type_of_credit_line_email: "",
      pf_credit_decisioning: "",
      pf_credit_decisioning_fico_vendor: "",
      pf_credit_decisioning_fico_vendor_other: "",
      pf_credit_decisioning_chc: "",
      pf_credit_decisioning_chc_company_name: "",
      pf_credit_decisioning_chc_contact_name: "",
      pf_credit_decisioning_chc_job_title: "",
      pf_credit_decisioning_chc_phone_number: "",
      pf_credit_decisioning_chc_phone_number_code: "",
      pf_credit_decisioning_chc_email: "",
      pf_workflow_and_decision_file: "",
      pf_manual_review: "",
      pf_manual_review_company_name: "",
      pf_manual_review_contact_name: "",
      pf_manual_review_job_title: "",
      pf_manual_review_phone_number: "",
      pf_manual_review_phone_number_code: "",
      pf_manual_review_email: "",
      pf_credit_limit: [],
      pf_credit_limit_modification: "",
      pf_kyc_process: "",
      pf_kyc_conduct: "",
      pf_kyc_conduct_other_company: "",
      pf_kyc_conduct_other_contact_name: "",
      pf_kyc_conduct_other_title: "",
      pf_kyc_conduct_other_phone: "",
      pf_kyc_conduct_other_phone_country: "",
      pf_kyc_conduct_other_email: "",
      pf_kyc_conduct_other_address: "",
      pf_kyb_process: "",
      pf_kyb_responsibility: "",
      pf_kyb_responsibility_other_company: "",
      pf_kyb_responsibility_other_contact_name: "",
      pf_kyb_responsibility_other_title: "",
      pf_kyb_responsibility_other_phone: "",
      pf_kyb_responsibility_other_phone_country: "",
      pf_kyb_responsibility_other_email: "",
      pf_kyb_responsibility_other_address: "",
      pf_card_order_placement: [],
      pf_card_order_placement_channel: [],
      pf_card_order_placement_channel_other: "",
      pf_card_activation_channel: [],
      pf_card_activation_channel_other: "",
      pf_pin_management: "",
      pf_pin_manage_default_pin: "",
      pf_pin_manage_default_pin_other: "",
      pf_pin_mailer: "",
      pf_offline_pin_support: "",
      pf_consumer_payment_opt: [],
      pf_consumer_payment_opt_other: "",
      pf_lockbox_services: "",
      pf_lockbox_services_other_company: "",
      pf_lockbox_services_other_contact_name: "",
      pf_lockbox_services_other_title: "",
      pf_lockbox_services_other_phone: "",
      pf_lockbox_services_other_phone_country: "",
      pf_lockbox_services_other_email: "",
      pf_min_payment_threshold: "",
      pf_min_payment_additional_amount: "",
      pf_payment_dist_opt_greater_min: "",
      pf_payment_dist_opt_for_min: "",
      pf_min_pc_pcalc_method: "",
      pf_min_pc_pprcntg_value: "",
      pf_min_pc_scalc_method: "",
      pf_min_pc_sprcntg_value: "",
      pf_payment_due_date_policy: "",
      pf_payment_due_date_policy_no_of_days: "",
      pf_payment_due_date_policy_fixed_date: "",
      pf_late_payment_penalty: "",
      pf_late_payment_fee: "",
      pf_grace_period: "",
      pf_grace_period_days: "",
      pf_card_account_statement: [],
      pf_statement_generation: "",
      pf_statment_generation_date: "",
      pf_credit_card_collection_detail: "",
      pf_credit_card_collection_detail_provider: "",
      pf_credit_card_collection_detail_provider_other: "",
      pf_credit_bureau_report_required: "",
      pf_credit_reporting_bureaus: [],
      pf_credit_reporting_bureaus_other: "",
      pf_card_usage_restriction: "",
      pf_cash_advance_limit: "",
      pf_cardholder_notification: "",
      pf_cardholder_notification_channels: "",
      pf_customer_support_channels: "",
      pf_customer_support_who_will_provide: "",
      pf_customer_support_provider_other_company: "",
      pf_customer_support_provider_other_contact_name: "",
      pf_customer_support_provider_other_title: "",
      pf_customer_support_provider_other_phone: "",
      pf_customer_support_provider_other_phone_country: "",
      pf_customer_support_provider_other_email: "",
      pf_clm_delinquent: [],
    },
  });
  const Manual = useRef(null);
  const fields = [
    "pf_applicable_pf_other",
    "pf_card_be_charged",
    "pf_type_of_credit_line",
    "pf_type_of_credit_line_company_name",
    "pf_type_of_credit_line_contact_name",
    "pf_type_of_credit_line_job_title",
    "pf_type_of_credit_line_phone_number",
    "pf_type_of_credit_line_phone_number_code",
    "pf_type_of_credit_line_email",
    "pf_credit_decisioning",
    "pf_credit_decisioning_fico_vendor",
    "pf_credit_decisioning_fico_vendor_other",
    "pf_credit_decisioning_chc",
    "pf_credit_decisioning_chc_company_name",
    "pf_credit_decisioning_chc_contact_name",
    "pf_credit_decisioning_chc_job_title",
    "pf_credit_decisioning_chc_phone_number",
    "pf_credit_decisioning_chc_phone_number_code",
    "pf_credit_decisioning_chc_email",
    "pf_workflow_and_decision_file",
    "pf_manual_review",
    "pf_manual_review_company_name",
    "pf_manual_review_contact_name",
    "pf_manual_review_job_title",
    "pf_manual_review_phone_number",
    "pf_manual_review_phone_number_code",
    "pf_manual_review_email",
    "pf_credit_limit_modification",
    "pf_kyc_process",
    "pf_kyc_conduct",
    "pf_kyc_conduct_other_company",
    "pf_kyc_conduct_other_contact_name",
    "pf_kyc_conduct_other_title",
    "pf_kyc_conduct_other_phone",
    "pf_kyc_conduct_other_phone_country",
    "pf_kyc_conduct_other_email",
    "pf_kyc_conduct_other_address",
    "pf_kyb_process",
    "pf_kyb_responsibility",
    "pf_kyb_responsibility_other_company",
    "pf_kyb_responsibility_other_contact_name",
    "pf_kyb_responsibility_other_title",
    "pf_kyb_responsibility_other_phone",
    "pf_kyb_responsibility_other_phone_country",
    "pf_kyb_responsibility_other_email",
    "pf_kyb_responsibility_other_address",
    "pf_card_order_placement_channel_other",
    "pf_card_activation_channel_other",
    "pf_pin_management",
    "pf_pin_manage_default_pin",
    "pf_pin_manage_default_pin_other",
    "pf_pin_mailer",
    "pf_offline_pin_support",
    "pf_consumer_payment_opt_other",
    "pf_lockbox_services",
    "pf_lockbox_services_other_company",
    "pf_lockbox_services_other_contact_name",
    "pf_lockbox_services_other_title",
    "pf_lockbox_services_other_phone",
    "pf_lockbox_services_other_phone_country",
    "pf_lockbox_services_other_email",
    "pf_min_payment_threshold",
    "pf_min_payment_additional_amount",
    "pf_payment_dist_opt_greater_min",
    "pf_payment_dist_opt_for_min",
    "pf_min_pc_pcalc_method",
    "pf_min_pc_pprcntg_value",
    "pf_min_pc_scalc_method",
    "pf_min_pc_sprcntg_value",
    "pf_payment_due_date_policy",
    "pf_payment_due_date_policy_no_of_days",
    "pf_payment_due_date_policy_fixed_date",
    "pf_late_payment_penalty",
    "pf_late_payment_fee",
    "pf_grace_period",
    "pf_grace_period_days",
    "pf_statement_generation",
    "pf_statment_generation_date",
    "pf_credit_card_collection_detail",
    "pf_credit_card_collection_detail_provider",
    "pf_credit_card_collection_detail_provider_other",
    "pf_credit_bureau_report_required",
    "pf_credit_reporting_bureaus_other",
    "pf_card_usage_restriction",
    "pf_cash_advance_limit",
    "pf_cardholder_notification",
    "pf_cardholder_notification_channels",
    "pf_customer_support_channels",
    "pf_customer_support_who_will_provide",
    "pf_customer_support_provider_other_company",
    "pf_customer_support_provider_other_contact_name",
    "pf_customer_support_provider_other_title",
    "pf_customer_support_provider_other_phone",
    "pf_customer_support_provider_other_phone_country",
    "pf_customer_support_provider_other_email",
  ];
  const arrayFields = [
    "pf_applicable_pf",
    "pf_credit_limit",
    "pf_card_order_placement",
    "pf_card_order_placement_channel",
    "pf_card_activation_channel",
    "pf_consumer_payment_opt",
    "pf_card_account_statement",
    "pf_credit_reporting_bureaus",
    "pf_clm_delinquent",
  ];

  useEffect(() => {
    try {
      if (!isFetching && Object.keys(formDataJson ?? {}).length) {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[5]["5_0"][field] ?? "");
        });
        arrayFields.forEach((field) => {
          methods.setValue(field, formDataJson[5]["5_0"][field] ?? []);
        });
      }
    } finally {
      methods.trigger();
    }
  }, [isFetching]);
  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      5: {
        ...addFormData["5"],
        "5_0": { ...values },
      },
    });
  };

  // Update form validation state when errosrs change
  React.useEffect(() => {
    // methods.trigger();
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("5_0", true);
    else setFormValidStates("5_0", false);
  }, [Object.keys(errors).length]);

  // function to handle the checbox group of applicable program features
  const handleApplicableFeatureChanges = (event) => {
    let selectedOptions;
    if (isNaN(event)) selectedOptions = event?.target?.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_applicable_pf") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    if (!updatedSelectedOptions.includes(11)) {
      methods.setValue("pf_applicable_pf_other", "");
    }
    methods.setValue("pf_applicable_pf", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };
  const formData = new FormData();

  const handleFileUpload = async (name) => {
    try {
      formData.append("file", Manual.current.fileUpload.files[0]);
      await fileUpload.mutate(formData);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fileUpload = useMutation({
    mutationFn: async (name) => {
      return await FilesUploadService.uploadFile(name);
    },
    onSuccess: (data) => {
      methods.setValue("pf_workflow_and_decision_file", data?.data?.url);
      methods.trigger();
      handleValueChanges();
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  const downloadFile = async (fileName) => {
    try {
      await fileDownload.mutate(fileName);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fileDownload = useMutation({
    mutationFn: async (fileName) => {
      return await FilesUploadService.downloadFile(fileName);
    },
    onSuccess: (data) => {
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";

      // Set the download attribute with the file name
      // link.setAttribute('download', fileName);

      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">Program Features</div>
            <div className="custom-label-light">
              Select the applicable program features.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_applicable_pf"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup {...field}>
                      <div i2c-grid="grid gap-sm">
                        {aplicableProgramFeatures.map((feature, index) => (
                          <I2cListItem
                            key={index + feature.label}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={feature.label}
                            sublabel=""
                            value=""
                            checked={methods
                              .watch("pf_applicable_pf")
                              .includes(feature.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleApplicableFeatureChanges(feature.value);
                            }}
                            type="checkbox"
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={feature.value}
                              label=""
                              filled
                              checked={methods
                                .watch("pf_applicable_pf")
                                .includes(feature.value)}
                              className="customCheckbox"
                            
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.pf_applicable_pf &&
                        methods.formState.touchedFields.pf_applicable_pf
                          ? true
                          : false
                      }
                      message={
                        errors.pf_applicable_pf?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
            {methods.watch("pf_applicable_pf")?.includes(11) && (
              <div key={"pf_applicable_pf_other"} className="mt-16 halfWidth">
                <div className="single-field-wrapper">
                  <Controller
                    name="pf_applicable_pf_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        placeholder="Other Details"
                        required
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Enter Details"
                        name={"pf_applicable_pf_other"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.pf_applicable_pf_other &&
                      methods.formState.touchedFields.pf_applicable_pf_other
                        ? true
                        : false
                    }
                    message={
                      errors.pf_applicable_pf_other?.message ?? "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip mb-16">
              <div className="sub-heading ">Credit Type</div>
              <I2cTooltip content="" placement="right-start">
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="single-field-wrapper ">
              <Controller
                name="pf_card_be_charged"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label=" How will the card be charged on each bill payment cycle?"
                    value={methods.watch("pf_card_be_charged")}
                    {...field}
                    name="pf_card_be_charged"
                  >
                    {["Revolving", "Charged"].map((cp, index) => (
                      <I2cRadioButton
                        key={index + cp}
                        onClick={(e) => {
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                        checked={
                          methods.watch("pf_card_be_charged") ===
                          cp.toLocaleLowerCase()
                        }
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_card_be_charged &&
                  methods.formState.touchedFields.pf_card_be_charged
                    ? true
                    : false
                }
                message={errors.pf_card_be_charged?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper ">
              <Controller
                name="pf_type_of_credit_line"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Define the type of the credit line."
                    value={methods.watch("pf_type_of_credit_line")}
                    {...field}
                    name="pf_type_of_credit_line"
                  >
                    {["Secure", "Unsecure"].map((cp, index) => (
                      <I2cRadioButton
                        key={index + cp}
                        onClick={(e) => {
                          [
                            "pf_type_of_credit_line_company_name",
                            "pf_type_of_credit_line_contact_name",
                            "pf_type_of_credit_line_job_title",
                            "pf_type_of_credit_line_phone_number",
                            "pf_type_of_credit_line_phone_number_code",
                            "pf_type_of_credit_line_email",
                          ].forEach((field) => methods.setValue(field, ""));
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                        checked={
                          methods.watch("pf_type_of_credit_line") ===
                          cp.toLocaleLowerCase()
                        }
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_type_of_credit_line &&
                  methods.formState.touchedFields.pf_type_of_credit_line
                    ? true
                    : false
                }
                message={
                  errors.pf_type_of_credit_line?.message ?? "Invalid input"
                }
              />
            </div>
          </div>

          {methods.watch("pf_type_of_credit_line") === "secure" && (
            <div i2c-grid="12">
              <div className="custom-label mb-16">
                If you will manage this on your own, please confirm who will be
                the credit data aggregator.
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_type_of_credit_line_company_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Name"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Company Name"
                          name={"pf_type_of_credit_line_company_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_type_of_credit_line_company_name &&
                        methods.formState.touchedFields
                          .pf_type_of_credit_line_company_name
                          ? true
                          : false
                      }
                      message={
                        errors.pf_type_of_credit_line_company_name?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_type_of_credit_line_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Name"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Contact Name"
                          name={"pf_type_of_credit_line_contact_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_type_of_credit_line_contact_name &&
                        methods.formState.touchedFields
                          .pf_type_of_credit_line_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.pf_type_of_credit_line_contact_name?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_type_of_credit_line_job_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Title"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Job Title"
                          name={"pf_type_of_credit_line_job_title"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_type_of_credit_line_job_title &&
                        methods.formState.touchedFields
                          .pf_type_of_credit_line_job_title
                          ? true
                          : false
                      }
                      message={
                        errors.pf_type_of_credit_line_job_title?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="INTERNATIONAL"
                      label="Cell Number"
                      name="pf_type_of_credit_line_phone_number"
                      size="large"
                      required
                      helpIcon=""
                      country-box
                      selectedCountry={methods.watch(
                        "pf_type_of_credit_line_phone_number_code",
                      ) || "US"}
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue(
                          "pf_type_of_credit_line_phone_number_code",
                          country,
                        );
                        methods.setValue(
                          "pf_type_of_credit_line_phone_number",
                          value,
                        );
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError(
                            "pf_type_of_credit_line_phone_number",
                            {
                              message: e.target.guide,
                            },
                          );
                        } else {
                          methods.clearErrors(
                            "pf_type_of_credit_line_phone_number",
                          );
                        }
                      }}
                      value={methods.watch(
                        "pf_type_of_credit_line_phone_number",
                      )}
                    />
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="pf_type_of_credit_line_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Enter Email"
                          required
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          type="email"
                          label="Email"
                          name={"pf_type_of_credit_line_email"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.pf_type_of_credit_line_email &&
                        methods.formState.touchedFields
                          .pf_type_of_credit_line_email
                          ? true
                          : false
                      }
                      message={
                        errors.pf_type_of_credit_line_email?.message ??
                        "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip">
              <div className="sub-heading">Credit Decisioning </div>
              <I2cTooltip
                content="Credit decisioning engine allows you to evaluate consumer credit risk based on risk parameters and decision flows. You can opt for a ‘manual review’ for cases rejected by the credit decisioning engine. 
              For the US region, i2c Inc. platform is integrated with two data bureaus: Equifax and TransUnion.  "
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="mt-16">
              <div i2c-grid="grid 12 gap-sm">
                <div i2c-grid="12">
                  <div className="single-field-wrapper ">
                    <Controller
                      name="pf_credit_decisioning"
                      control={control}
                      render={({ field }) => (
                        <I2cRadioGroup
                          label="Will i2c Inc. provide credit decisioning or adjudication services?"
                          value={methods.watch("pf_credit_decisioning")}
                          {...field}
                          name="pf_credit_decisioning"
                        >
                          {["Yes", "No"].map((cp, index) => (
                            <I2cRadioButton
                              key={index + cp}
                              onClick={(e) => {
                                if (e.target.value === "no") {
                                  methods.setValue(
                                    "pf_credit_decisioning_fico_vendor",
                                    "",
                                  );
                                  methods.setValue(
                                    "pf_credit_decisioning_fico_vendor_other",
                                    "",
                                  );
                                } else {
                                  [
                                    "pf_credit_decisioning_chc",
                                    "pf_credit_decisioning_chc_company_name",
                                    "pf_credit_decisioning_chc_contact_name",
                                    "pf_credit_decisioning_chc_job_title",
                                    "pf_credit_decisioning_chc_phone_number",
                                    "pf_credit_decisioning_chc_phone_number_code",
                                    "pf_credit_decisioning_chc_email",
                                  ].forEach((field) =>
                                    methods.setValue(field, ""),
                                  );
                                }
                                field.onChange(e);
                                methods.trigger();
                                handleValueChanges();
                              }}
                              checked={
                                methods.watch("pf_credit_decisioning") ===
                                cp.toLocaleLowerCase()
                              }
                              value={cp.toLocaleLowerCase()}
                            >
                              {cp}
                            </I2cRadioButton>
                          ))}
                        </I2cRadioGroup>
                      )}
                    />
                    <ErrorMessage
                      show={
                        errors.pf_credit_decisioning &&
                        methods.formState.touchedFields.pf_credit_decisioning
                          ? true
                          : false
                      }
                      message={
                        errors.pf_credit_decisioning?.message ?? "Invalid input"
                      }
                    />
                  </div>
                </div>
                {methods.watch("pf_credit_decisioning") === "yes" && (
                  <>
                    <div i2c-grid="12">
                      <div className="single-field-wrapper ">
                        <Controller
                          name="pf_credit_decisioning_fico_vendor"
                          control={control}
                          render={({ field }) => (
                            <I2cRadioGroup
                              label="Which vendor do you work with for FICO score?"
                              value={methods.watch(
                                "pf_credit_decisioning_fico_vendor",
                              )}
                              {...field}
                              name="pf_credit_decisioning_fico_vendor"
                              onI2cChange={(e) => {
                                if (e.target.value !== "other")
                                  methods.setValue(
                                    "pf_credit_decisioning_fico_vendor_other",
                                    "",
                                  );
                                field.onChange(e);
                                methods.trigger();
                                handleValueChanges();
                              }}
                            >
                              <div i2c-grid="grid gap-sm">
                                {["Equifax", "Trans Union", "Other"].map(
                                  (fisco, index) => (
                                    <I2cListItem
                                      key={index + fisco}
                                      i2c-grid="4@md"
                                      variant="receipt"
                                      label={fisco}
                                      sublabel=" "
                                      value=""
                                      type="checkbox"
                                      checked={
                                        methods.watch(
                                          "pf_credit_decisioning_fico_vendor",
                                        ) === fisco.toLocaleLowerCase()
                                      }
                                    >
                                      <I2cRadio
                                        slot="prefix"
                                        name="of_fisco"
                                        filled
                                        label=""
                                        checked={
                                          methods.watch(
                                            "pf_credit_decisioning_fico_vendor",
                                          ) === fisco.toLocaleLowerCase()
                                        }
                                        value={fisco.toLocaleLowerCase()}
                                      ></I2cRadio>
                                    </I2cListItem>
                                  ),
                                )}
                              </div>
                            </I2cRadioGroup>
                          )}
                        />
                        <ErrorMessage
                          show={
                            errors.pf_credit_decisioning_fico_vendor &&
                            methods.formState.touchedFields
                              .pf_credit_decisioning_fico_vendor
                              ? true
                              : false
                          }
                          message={
                            errors.pf_credit_decisioning_fico_vendor?.message ??
                            "Invalid input"
                          }
                        />
                      </div>
                    </div>
                    {methods.watch("pf_credit_decisioning_fico_vendor") ===
                      "other" && (
                      <div i2c-grid="12@md " className="halfWidth">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_credit_decisioning_fico_vendor_other"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Please Specify"
                                required
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Please Specify"
                                name={"pf_credit_decisioning_fico_vendor_other"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_credit_decisioning_fico_vendor_other &&
                              methods.formState.touchedFields
                                .pf_credit_decisioning_fico_vendor_other
                                ? true
                                : false
                            }
                            message={
                              errors.pf_credit_decisioning_fico_vendor_other
                                ?.message ?? "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                    )}
                  </>
                )}
                {methods.watch("pf_credit_decisioning") === "no" && (
                  <>
                    <div i2c-grid="12" className="section-space-top">
                      <div className="sub-heading mb-4">
                        Credit History Check
                      </div>
                      <div className="single-field-wrapper ">
                        <Controller
                          name="pf_credit_decisioning_chc"
                          control={control}
                          render={({ field }) => (
                            <I2cRadioGroup
                              label="Who will be responsible for verifying the cardholder credit history with the credit bureaus."
                              value={methods.watch("pf_credit_decisioning_chc")}
                              {...field}
                              name="pf_credit_decisioning_chc"
                              onI2cChange={(e) => {
                                if (e.target.value !== "other") {
                                  [
                                    "pf_credit_decisioning_chc_company_name",
                                    "pf_credit_decisioning_chc_contact_name",
                                    "pf_credit_decisioning_chc_job_title",
                                    "pf_credit_decisioning_chc_phone_number",
                                    "pf_credit_decisioning_chc_phone_number_code",
                                    "pf_credit_decisioning_chc_email",
                                  ].forEach((field) =>
                                    methods.setValue(field, ""),
                                  );
                                }
                                field.onChange(e);
                                methods.trigger();
                                handleValueChanges();
                              }}
                            >
                              <div i2c-grid="grid gap-sm">
                                {[
                                  {
                                    label: "Managed by sponsor Bank/Issuer/ISO",
                                    value: "managed-by-sponser-bank",
                                  },
                                  { label: "Other", value: "other" },
                                ].map((fisco, index) => (
                                  <I2cListItem
                                    key={index + fisco.label}
                                    i2c-grid="6@md"
                                    variant="receipt"
                                    label={fisco.label}
                                    sublabel=" "
                                    value=""
                                    type="checkbox"
                                    checked={
                                      methods.watch(
                                        "pf_credit_decisioning_chc",
                                      ) === fisco.value
                                    }
                                  >
                                    <I2cRadio
                                      slot="prefix"
                                      name="of_fisco"
                                      filled
                                      label=""
                                      checked={
                                        methods.watch(
                                          "pf_credit_decisioning_chc",
                                        ) === fisco.value
                                      }
                                      value={fisco.value}
                                    ></I2cRadio>
                                  </I2cListItem>
                                ))}
                              </div>
                            </I2cRadioGroup>
                          )}
                        />
                        <ErrorMessage
                          show={
                            errors.pf_credit_decisioning_chc &&
                            methods.formState.touchedFields
                              .pf_credit_decisioning_chc
                              ? true
                              : false
                          }
                          message={
                            errors.pf_credit_decisioning_chc?.message ??
                            "Invalid input"
                          }
                        />
                      </div>
                      {methods.watch("pf_credit_decisioning_chc") ===
                        "other" && (
                        <div className="mt-16">
                          <div className="custom-label mb-16">
                            If using a 3rd Party Vendor, please provide details:
                          </div>
                          <div i2c-grid="grid gap-column-sm gap-row-md">
                            <div i2c-grid="6@md">
                              <div className="single-field-wrapper">
                                <Controller
                                  name="pf_credit_decisioning_chc_company_name"
                                  control={control}
                                  render={({ field }) => (
                                    <I2cInput
                                      {...field}
                                      className="single-input-field"
                                      placeholder="Enter Name"
                                      required
                                      onI2cInput={(e) => {
                                        const value = e.target.value;
                                        field.onChange(value);
                                        handleValueChanges();
                                      }}
                                      size="large"
                                      label="Company Name"
                                      name={
                                        "pf_credit_decisioning_chc_company_name"
                                      }
                                    />
                                  )}
                                />
                                {/* <ErrorMessage
                                  show={
                                    errors.pf_credit_decisioning_chc_company_name &&
                                    methods.formState.touchedFields
                                      .pf_credit_decisioning_chc_company_name
                                      ? true
                                      : false
                                  }
                                  message={
                                    errors
                                      .pf_credit_decisioning_chc_company_name
                                      ?.message ?? "Invalid input"
                                  }
                                /> */}
                              </div>
                            </div>
                            <div i2c-grid="6@md">
                              <div className="single-field-wrapper">
                                <Controller
                                  name="pf_credit_decisioning_chc_contact_name"
                                  control={control}
                                  render={({ field }) => (
                                    <I2cInput
                                      {...field}
                                      className="single-input-field"
                                      placeholder="Enter Name"
                                      required
                                      onI2cInput={(e) => {
                                        const value = e.target.value;
                                        field.onChange(value);
                                        handleValueChanges();
                                      }}
                                      size="large"
                                      label="Contact Name"
                                      name={
                                        "pf_credit_decisioning_chc_contact_name"
                                      }
                                    />
                                  )}
                                />
                                {/* <ErrorMessage
                                  show={
                                    errors.pf_credit_decisioning_chc_contact_name &&
                                    methods.formState.touchedFields
                                      .pf_credit_decisioning_chc_contact_name
                                      ? true
                                      : false
                                  }
                                  message={
                                    errors
                                      .pf_credit_decisioning_chc_contact_name
                                      ?.message ?? "Invalid input"
                                  }
                                /> */}
                              </div>
                            </div>
                            <div i2c-grid="6@md">
                              <div className="single-field-wrapper">
                                <Controller
                                  name="pf_credit_decisioning_chc_job_title"
                                  control={control}
                                  render={({ field }) => (
                                    <I2cInput
                                      {...field}
                                      className="single-input-field"
                                      placeholder="Enter Title"
                                      required
                                      onI2cInput={(e) => {
                                        const value = e.target.value;
                                        field.onChange(value);
                                        handleValueChanges();
                                      }}
                                      size="large"
                                      label="Job Title"
                                      name={
                                        "pf_credit_decisioning_chc_job_title"
                                      }
                                    />
                                  )}
                                />
                                {/* <ErrorMessage
                                  show={
                                    errors.pf_credit_decisioning_chc_job_title &&
                                    methods.formState.touchedFields
                                      .pf_credit_decisioning_chc_job_title
                                      ? true
                                      : false
                                  }
                                  message={
                                    errors.pf_credit_decisioning_chc_job_title
                                      ?.message ?? "Invalid input"
                                  }
                                /> */}
                              </div>
                            </div>
                            <div i2c-grid="6@md">
                              <div className="single-field-wrapper">
                                <I2cPhoneField
                                  format="INTERNATIONAL"
                                  label="Cell Number"
                                  name="pf_credit_decisioning_chc_phone_number"
                                  size="large"
                                  required
                                  helpIcon=""
                                  country-box
                                  selectedCountry={methods.watch(
                                    "pf_credit_decisioning_chc_phone_number_code",
                                  ) || "US"}
                                  errorMessageVisible={false}
                                  onI2cChange={(e) => {
                                    const country = e.target.country;
                                    const isValid = e.target.isValid;
                                    const value = e.target.value;
                                    methods.setValue(
                                      "pf_credit_decisioning_chc_phone_number_code",
                                      country,
                                    );
                                    methods.setValue(
                                      "pf_credit_decisioning_chc_phone_number",
                                      value,
                                    );
                                    handleValueChanges();
                                    if (!isValid) {
                                      methods.setError(
                                        "pf_credit_decisioning_chc_phone_number",
                                        {
                                          message: e.target.guide,
                                        },
                                      );
                                    } else {
                                      methods.clearErrors(
                                        "pf_credit_decisioning_chc_phone_number",
                                      );
                                    }
                                  }}
                                  value={methods.watch(
                                    "pf_credit_decisioning_chc_phone_number",
                                  )}
                                />
                              </div>
                            </div>
                            <div i2c-grid="6@md">
                              <div className="single-field-wrapper">
                                <Controller
                                  name="pf_credit_decisioning_chc_email"
                                  control={control}
                                  render={({ field }) => (
                                    <I2cInput
                                      {...field}
                                      className="single-input-field"
                                      placeholder="Enter Email"
                                      required
                                      onI2cInput={(e) => {
                                        const value = e.target.value;
                                        field.onChange(value);
                                        handleValueChanges();
                                      }}
                                      size="large"
                                      label="Email"
                                      type="email"
                                      name={"pf_credit_decisioning_chc_email"}
                                    />
                                  )}
                                />
                                {/* <ErrorMessage
                                  show={
                                    errors.pf_credit_decisioning_chc_email &&
                                    methods.formState.touchedFields
                                      .pf_credit_decisioning_chc_email
                                      ? true
                                      : false
                                  }
                                  message={
                                    errors.pf_credit_decisioning_chc_email
                                      ?.message ?? "Invalid input"
                                  }
                                /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div i2c-grid="12">
            <div className="custom-label mb-16">
              Please provide the required workflow and decision logic in a
              separate attachment.
            </div>
            <I2cFileUpload
              ref={Manual}
              autoProcessQueue={false}
              no-mobile-controls
              max-files={1}
              className="customFileUpload"
              setAcceptedFiles=".pdf"
              icon="linear-document-upload"
              label="Click to upload"
              caption="or drag and drop"
              name="pf_workflow_and_decision_file"
              message="Only PDF file (max. 5MB)."
              onI2cFileRemoved={(e) => {
                methods.setValue("pf_workflow_and_decision_file", "");
                methods.trigger();
                handleValueChanges();
              }}
              onI2cAddedFile={(e) => {
                handleFileUpload(
                  Manual.current.getDropZone().files[
                    Manual.current.getDropZone().files.length - 1
                  ],
                );
              }}
            />

            {Object.keys(formDataJson ?? {}).length ? (
              <>
                {formDataJson[5]["5_0"]?.pf_workflow_and_decision_file !=
                  null && (
                  <div className="mt-16">
                    <I2cButton
                      size="small"
                      variant="link color"
                      className=""
                      onClick={() => {
                        downloadFile(
                          formDataJson[5]["5_0"]?.pf_workflow_and_decision_file,
                        );
                      }}
                    >
                      <I2cIcon
                        slot="prefix"
                        name="linear-document-download"
                        label="add"
                      ></I2cIcon>{" "}
                      Download File
                    </I2cButton>
                  </div>
                )}
              </>
            ) : null}

            {/*<div className="mt-16">*/}
            {/*  <I2cButton size="small" variant="link color" className="">*/}
            {/*    <I2cIcon*/}
            {/*      slot="prefix"*/}
            {/*      name="linear-document-download"*/}
            {/*      label="add"*/}
            {/*    ></I2cIcon>{" "}*/}
            {/*    Download sample template*/}
            {/*  </I2cButton>*/}
            {/*</div>*/}
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper ">
              <Controller
                name="pf_manual_review"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label=" Please confirm if you want to enable a manual review in cases where an application has been rejected or marked for review."
                    value={methods.watch("pf_manual_review")}
                    {...field}
                    name="pf_manual_review"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No"].map((cp, index) => (
                      <I2cRadioButton
                        key={index + cp}
                        onClick={(e) => {
                          if (e.target.value === "no") {
                            [
                              "pf_manual_review_company_name",
                              "pf_manual_review_contact_name",
                              "pf_manual_review_job_title",
                              "pf_manual_review_phone_number",
                              "pf_manual_review_phone_number_code",
                              "pf_manual_review_email",
                            ].forEach((field) => methods.setValue(field, ""));
                          }
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                        checked={
                          methods.watch("pf_manual_review") ===
                          cp.toLocaleLowerCase()
                        }
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_manual_review &&
                  methods.formState.touchedFields.pf_manual_review
                    ? true
                    : false
                }
                message={errors.pf_manual_review?.message ?? "Invalid input"}
              />
            </div>
            {methods.watch("pf_manual_review") === "yes" && (
              <div className="mt-16">
                <div className="custom-label mb-16">
                  If using a 3rd Party Vendor, please provide details:
                </div>
                <div i2c-grid="grid gap-column-sm gap-row-md">
                  <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_manual_review_company_name"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Name"
                            required
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Company Name"
                            name={"pf_manual_review_company_name"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_manual_review_company_name &&
                          methods.formState.touchedFields
                            .pf_manual_review_company_name
                            ? true
                            : false
                        }
                        message={
                          errors.pf_manual_review_company_name?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_manual_review_contact_name"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Name"
                            required
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Contact Name"
                            name={"pf_manual_review_contact_name"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_manual_review_contact_name &&
                          methods.formState.touchedFields
                            .pf_manual_review_contact_name
                            ? true
                            : false
                        }
                        message={
                          errors.pf_manual_review_contact_name?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_manual_review_job_title"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Title"
                            required
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Job Title"
                            name={"pf_manual_review_job_title"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_manual_review_job_title &&
                          methods.formState.touchedFields
                            .pf_manual_review_job_title
                            ? true
                            : false
                        }
                        message={
                          errors.pf_manual_review_job_title?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
                      <I2cPhoneField
                        format="INTERNATIONAL"
                        label="Cell Number"
                        name="pf_manual_review_phone_number"
                        size="large"
                        required
                        helpIcon=""
                        country-box
                        selectedCountry={methods.watch(
                          "pf_manual_review_phone_number_code",
                        ) || "US"}
                        errorMessageVisible={false}
                        onI2cChange={(e) => {
                          const country = e.target.country;
                          const isValid = e.target.isValid;
                          const value = e.target.value;
                          methods.setValue(
                            "pf_manual_review_phone_number_code",
                            country,
                          );
                          methods.setValue(
                            "pf_manual_review_phone_number",
                            value,
                          );
                          handleValueChanges();
                          if (!isValid) {
                            methods.setError("pf_manual_review_phone_number", {
                              message: e.target.guide,
                            });
                          } else {
                            methods.clearErrors(
                              "pf_manual_review_phone_number",
                            );
                          }
                        }}
                        value={methods.watch("pf_manual_review_phone_number")}
                      />
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_manual_review_email"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Email"
                            required
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            type="email"
                            label="Email"
                            name={"pf_manual_review_email"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_manual_review_email &&
                          methods.formState.touchedFields.pf_manual_review_email
                            ? true
                            : false
                        }
                        message={
                          errors.pf_manual_review_email?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <CreditLimits
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
        />
        <PaymentCard
          control={control}
          handleValueChanges={handleValueChanges}
          methods={methods}
          errors={errors}
        />
      </div>
    </React.Fragment>
  );
};

export default GeneralInfoProgramFeatures;
